import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { PillItem } from ".";
import { zoneConfig } from "../../config/zones";
import { nav } from "../../config/navigation";

const Breadcrumb = ({ items, reverse, highlightIndex }) => {
	const [breadcrumbItems, setBreadcrumbItems] = useState([]);

	useEffect(() => {
		//Copy before reversing - reversing in place mutates the caller's state
		if (reverse) setBreadcrumbItems([...items].reverse());
		else setBreadcrumbItems(items);
	}, [items]);

	return (
		<div className="flex flex-wrap gapCol-xsmall gapRow-xsmall aItems-center">
			{breadcrumbItems?.map((item, idx) => {
				//Every segment is a pill; the current (deepest) zone is highlighted, ancestors are muted
				const isCurrent = idx + 1 === highlightIndex;
				return (
					<Link
						key={`${item.type}-${item.id}`}
						to={`${nav.zones.base}/${nav.zones.management}?zoneId=${item.id}`}>
						<PillItem
							value={item.label}
							icon={zoneConfig[item.type].icon}
							wrapperStyle={isCurrent ? "blue1" : "blue4"}
						/>
					</Link>
				);
			})}
		</div>
	);
};

export default Breadcrumb;
